import React from "react";

const PartnersTopNew = ({ partnersTopData = [] }) => {

    if (!partnersTopData.length) return null;

    return (
        <section className="pt-[60px] pb-[30px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <div className="flex flex-wrap gap-10  justify-center items-start ">
                    {partnersTopData.map(({partners_top_select: {partners_top_status, partners_top_item}}, groupIndex) => (
                        <div className={`flex flex-col text-center justify-center toppartner-new-${groupIndex} w-full ${
                                groupIndex === 2 ? "md:w-[90%] lg:w-[70%]" : "md:w-[calc(50%-20px)]"
                            }`} key={groupIndex}>
                            {/* Название */}
                            <h3 className="font-bold uppercase text-[24px] sm:text-[26px] text-[#000] mb-3">{partners_top_status}</h3>
                            {/* Лого */}
                            <div className="flex gap-8 lg:gap-12 justify-center items-end">
                                {partners_top_item.map(({acf: {p_url, p_thumbnail, p_logo_width}}, partnerIndex) => (
                                    <a
                                        key={`${groupIndex}-${partnerIndex}`}
                                        href={p_url ? p_url : '/'}
                                        className="flex-1 max-w-56"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img  src={p_thumbnail} alt={partners_top_status}className=" inline-block object-contain"/>
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PartnersTopNew;